import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";

import "./styles.scss";

export const FauxInput = ({
  children,
  className,
  icon,
  onBlur,
  onClick,
  onFocus,
  placeholder,
  ...props
}) => (
  <div
    className={createClassNameString(["apti-CL apti-FauxInput", className])}
    onBlur={onBlur}
    onClick={onClick}
    onFocus={onFocus}
    {...props}
  >
    <>
      {children.length &&
      children.reduce((previousValue, currentValue) => {
        switch (typeof currentValue) {
          case "array":
            return !!currentValue.length || previousValue;

          default:
            return !!currentValue || previousValue;
        }
      }).length !== 0
        ? children
        : placeholder}
      {icon}
    </>
  </div>
);

FauxInput.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  icon: PropTypes.element,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
};

FauxInput.defaultProps = {
  children: <></>,
  className: undefined,
  icon: <></>,
  onBlur: () => {},
  onClick: () => {},
  onFocus: () => {},
  placeholder: "",
};
